/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo panel bar
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var PanelBar = kendo.ui.PanelBar;
    if (!PanelBar || PanelBar.updated) return;

    var AVATAR = "avatar",
        ITEM = ".k-item",
        ANIMATION_COMPLETE = "animationComplete",
        ACTIVECLASS = "k-state-active",
        ACTIVATE = "activate",
        ARIA_EXPANDED = "aria-expanded",
        ARIA_HIDDEN = "aria-hidden",
        VISIBLE = ":visible";

    /**
     * Function is almost same as original. Only difference is ANIMATION_COMPLETE event that is triggered on the end of animation.
     * @param {any} element
     * @param {any} visibility
     */
    function panelBarToggleGroup(element, visibility) {
        var that = this,
            animationSettings = that.options.animation,
            animation = animationSettings.expand,
            hasCollapseAnimation = animationSettings.collapse && 'effects' in animationSettings.collapse,
            collapse = $.extend({}, animationSettings.expand, animationSettings.collapse);

        if (!hasCollapseAnimation) {
            collapse = $.extend(collapse, { reverse: true });
        }
        if (element.is(VISIBLE) != visibility) {
            that._animating = false;
            return;
        }
        element.parent().attr(ARIA_EXPANDED, !visibility).attr(ARIA_HIDDEN, visibility).toggleClass(ACTIVECLASS, !visibility).find('> .k-link > .k-panelbar-collapse,> .k-link > .k-panelbar-expand').toggleClass('k-i-arrow-n', !visibility).toggleClass('k-panelbar-collapse', !visibility).toggleClass('k-i-arrow-s', visibility).toggleClass('k-panelbar-expand', visibility);
        if (visibility) {
            animation = $.extend(collapse, { hide: true });
            animation.complete = function () {
                that._animationCallback();
                that._triggerEvent(ANIMATION_COMPLETE, element.closest(ITEM));
            };
        } else {
            animation = $.extend({
                complete: function (element) {
                    that._triggerEvent(ACTIVATE, element.closest(ITEM));
                    that._animationCallback();
                    that._triggerEvent(ANIMATION_COMPLETE, element.closest(ITEM));
                }
            }, animation);
        }
        element.kendoStop(true, true).kendoAnimate(animation);
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldPanelBarInit = PanelBar.fn.init,
        newPanelBarInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "panelbar", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            // remove avatar class before the wrapper gets created
            $element.removeClass(AVATAR);
            // add new event
            if (!$.isArray(self.events)) self.events = [];
            if (self.events.indexOf(ANIMATION_COMPLETE) < 0) self.events.push(ANIMATION_COMPLETE);
            // call original constructor
            oldPanelBarInit.call(self, element, options);
        };

    /**
     * Programmatically expand any deep level item, by its selector
     *
     */
    function deepSelect(targetSelector) {
        var that = this;
        var $target = $(targetSelector);
        $target.parents("li").each(function(index) {
            that.expand(this, false)
        });
        that.select($target);
    }

    /**
     * Extend original method _updateSelected
     * to be able to collapse expanded item in "single" mode
     */
    var oldUpdateSelected = PanelBar.fn._updateSelected,
        newUpdateSelected = function (link, skipChange) {
            var self = this,
                item = link.parent(ITEM);
            // call original constructor
            oldUpdateSelected.call(self, link, skipChange);
            // extend functionality
            if ($(item).is("." + ACTIVECLASS)) {
                window.setTimeout(function(){
                    self.collapse(item);
                }, 1);
            }
        };

    PanelBar = PanelBar.extend({
        // new init
        init: newPanelBarInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions(),
        // updated methods
        _toggleGroup: panelBarToggleGroup,
        _updateSelected: newUpdateSelected,
        // custom methods
        deepSelect: deepSelect
    });

    kendo.updatePlaceholderLogic(PanelBar);
    kendo.moveFunctionalityToWrapper(PanelBar);

    PanelBar.updated = true;

    kendo.ui.plugin(PanelBar);

})(window.kendo.jQuery);
